<template>
  <table id="table" border="1" cellpadding="0" cellspacing="0" style="width: 100%">
    <caption id="tablePrintText">
      <div style="font-weight: 600; letter-spacing: 0px">{{ hotelInfo.name }}</div>
      <div style="font-weight: 600">单位核销统计汇总</div>
      <div style="display: flex; justify-content: space-between">
        <div>
          <span style="font-weight: 600">营业日期:{{ listQuery.businessDate }}</span>
        </div>
        <div>
          <span style="font-weight: 600">打印人:{{ employee.name }}</span>
          <span style="font-weight: 600">打印时间:{{ currentTime }}</span>
        </div>
      </div>
    </caption>
    <thead>
      <tr v-if="exportShow">
        <th :colspan="tabelTitel.length">{{ hotelInfo.name }}</th>
      </tr>
      <tr v-if="exportShow">
        <th :colspan="tabelTitel.length">单位核销统计汇总</th>
      </tr>
      <tr v-if="exportShow">
        <th :colspan="tabelTitel.length / 2">
          <div style="font-weight: 600; text-align: left">
            <template>营业日期:{{ listQuery.businessDate }}</template>
          </div>
        </th>
        <th style="text-align: right" :colspan="(tabelTitel.length + 1) / 2">打印人:{{ employee.name }} 打印时间:{{ currentTime }}</th>
      </tr>
      <tr>
        <th style="position: sticky; top: 0; background-color: #fff" v-for="th in tabelTitel" :key="th.code">
          {{ th.chinese_desc }}
        </th>
      </tr>
    </thead>
    <tbody>
      <!-- 普通数据行 -->
      <tr v-for="(row, index) in mergedTableData" :key="index" :class="{ 'group-summary-row': row._isSummary }">
        <td v-for="col in tabelTitel" :key="col.code">
          <template v-if="col.code === ''">
            {{ row.序号 }}
          </template>
          <template v-else>
            {{ row[col.code] }}
          </template>
        </td>
      </tr>
      <tr v-if="sumsTotal && sumsTotal.length" class="total-summary">
        <td v-for="(sum, idx) in sumsTotal" :key="idx">{{ sum }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
export default {
  props: {
    tabelTitel: {
      type: Array,
      default: [],
    },
    tabelList: {
      type: Array,
      default: [],
    },
    sumsTotal: {
      type: Array,
      default: [],
    },
    listQuery: {
      type: Object,
    },
    exportShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sumFields() {
      return ['c1', 'totalPrice1', 'c2', 'totalPrice2', 'c3', 'totalPrice3', 'writeOffCount', 'totalPrice', 'payTotal1', 'payTotal2', 'payTotal3', 'payTotal'];
    },
    // 生成带团队小计行的完整表格数据
    mergedTableData() {
      if (!this.tabelList || this.tabelList.length === 0) return [];

      // 1. 按单位名称排序，保证同单位连续显示
      const sortedList = [...this.tabelList].sort((a, b) => {
        const nameA = a.name ? String(a.name).trim() : '';
        const nameB = b.name ? String(b.name).trim() : '';
        return nameA.localeCompare(nameB);
      });

      // 2. 确定小计字段：优先使用 sumFields，若为空则自动识别数值字段
      let fieldsToSum = [];
      if (this.sumFields && this.sumFields.length) {
        fieldsToSum = this.sumFields;
      } else {
        fieldsToSum = this.getNumericFields(sortedList);
      }

      const result = [];
      let currentGroupName = '';
      let currentGroupItems = [];
      let globalSerial = 0;

      const buildSummaryRow = (groupName, items) => {
        const summaryRow = { _isSummary: true };
        this.tabelTitel.forEach(col => {
          const colCode = col.code;
          if (colCode === '') {
            summaryRow.序号 = '小计';
          } else if (colCode === 'name') {
            summaryRow[colCode] = ''; // ✅ 已修改：不显示单位名称
          } else if (fieldsToSum.includes(colCode)) {
            let total = 0;
            items.forEach(item => {
              const rawVal = item[colCode];
              const num = parseFloat(rawVal);
              if (!isNaN(num)) total += num;
            });
            summaryRow[colCode] = Number.isInteger(total) ? total : total.toFixed(2);
          } else {
            summaryRow[colCode] = '';
          }
        });
        return summaryRow;
      };

      // 4. 遍历分组，插入数据行和小计行
      for (let i = 0; i < sortedList.length; i++) {
        const row = sortedList[i];
        const groupName = row.name ? String(row.name).trim() : '未分类';

        if (currentGroupName !== groupName) {
          if (currentGroupItems.length > 0) {
            // 插入上一组的数据行
            currentGroupItems.forEach(item => {
              globalSerial++;
              result.push({
                ...item,
                _isSummary: false,
                序号: globalSerial,
              });
            });
            // 插入上一组的小计行
            result.push(buildSummaryRow(currentGroupName, currentGroupItems));
            currentGroupItems = [];
          }
          currentGroupName = groupName;
        }
        currentGroupItems.push(row);
      }

      // 处理最后一组
      if (currentGroupItems.length > 0) {
        currentGroupItems.forEach(item => {
          globalSerial++;
          result.push({
            ...item,
            _isSummary: false,
            序号: globalSerial,
          });
        });
        result.push(buildSummaryRow(currentGroupName, currentGroupItems));
      }

      return result;
    },
  },
  data() {
    return {
      employee: JSON.parse(localStorage.getItem('user')),
      currentTime: DateUtils.formatDate(new Date(), 'yyyy-MM-dd hh:mm'), //当前的时间
      hotelInfo: JSON.parse(localStorage.getItem('hotel')),
      queryShiftValue: '',
    };
  },
  mounted() {},
};
</script>
<style scoped>
.group-summary-row {
  background-color: #f5f5f5;
  font-weight: 600;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.total-summary {
  background-color: #e8f4f8;
  font-weight: 700;
}
</style>
